import React, { Component, Fragment } from "react";
import { CostEstimateRowsCalculator } from "../services/costEstimateRowsService";

class CostEstimateValue extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        const { isEditable, quantity } = this.props;
        const quantityIsValid = !isNaN(quantity) && parseInt(quantity) > 0;
        let { ...allProps } = this.props;
        allProps.multiplier = quantity;

        return (
            <div className="row mb-2">
                {isEditable && quantityIsValid && (
                    <Fragment>
                        <input
                            type="hidden"
                            value={
                                Number(
                                    CostEstimateRowsCalculator.getTotalPriceAfterDiscount(
                                        allProps
                                    )
                                ) || 0
                            }
                            name="value_amount"
                            readOnly
                        />
                        <input
                            type="hidden"
                            value={
                                Number(
                                    CostEstimateRowsCalculator.getTotalMarginSek(
                                        allProps
                                    )
                                ) || 0
                            }
                            name="margin_amount"
                            readOnly
                        />
                    </Fragment>
                )}
            </div>
        );
    }
}

export default CostEstimateValue;
